/**
 * Styles for ChallengeInfo component and its sub-components
 * Uses Material-UI's makeStyles for consistent theming
 */

import makeStyles from '@material-ui/core/styles/makeStyles'
import { isRtl } from '../../i18nInit'

/**
 * Main styles for ChallengeInfo component
 */
export const useChallengeInfoStyles = makeStyles((theme) => ({
  wrapper: {
    paddingBottom: '16px',
  },
  grid: {
    marginBottom: '16px',
    alignItems: 'center',
  },
  logo: {
    display: 'inline-block',
    height: '40px',
    width: 'auto',
    maxWidth: '100%',
    boxSizing: 'content-box',
  },
  listItem: {
    flexWrap: 'nowrap',
    alignItems: 'start',
    padding: '10px',
    marginBottom: '8px',
  },
  listItemDense: {
    padding: 0,
    marginBottom: '10px',
    background: 'transparent',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  listItemText: {
    marginTop: 0,
    marginBottom: 0,
    textAlign: isRtl ? 'right' : 'left',
  },
  listItemTextPrimary: {
    fontWeight: 700,
    fontSize: '11px',
    lineHeight: '13px',
    opacity: 0.7,
    marginBottom: '2px',
  },
  listItemTextSecondary: {
    fontWeight: 500,
    fontSize: '13px',
    lineHeight: '16px',
    color: 'inherit',
  },
}))

/**
 * Styles for organizer logo display
 * @param isSvg - Whether the logo is an SVG file (affects sizing/padding)
 */
export const getLogoStyles = (isSvg: boolean) => ({
  height: isSvg ? '40px' : '30px',
  padding: isSvg ? '0' : '10px',
  background: isSvg ? 'transparent' : 'white',
  borderRadius: isSvg ? '0' : '8px',
})
